import * as Switch from '@radix-ui/react-switch'
import { SwitchThumbVariants } from './switch-thumb.styles'

export const SwitchThumb = () => {
  return (
    <Switch.Thumb
      className={SwitchThumbVariants()}
      data-testid="switch-thumb"
    />
  )
}
